<template>
    <l-map :style="'height:'+ height" :zoom="zoom" :center="center" :bounds="bounds"  :max-bounds="maxBounds" :minZoom="minZoom"
     id="mapid" style="z-index:1"
    >
      <l-tile-layer :url="url" id="mapTileLayer"></l-tile-layer>
      <l-layer-group ref="layergroup" >
        <l-marker v-for="marker in markersInMap" 
          :id="'marker-' + marker.id"
          @click="clickOnMarker"
          :lat-lng="marker.location" :options="{customId:marker.id, title:marker.title}"
          :key="marker.id"
          :draggable="marker.draggable"      
          @dragstart="beginDrag"
          @dragover.stop
          class="marker" 
        ></l-marker>
      </l-layer-group>
    </l-map>
</template>

<script>
import { LMap, LTileLayer,LLayerGroup, LMarker } from 'vue2-leaflet';
import {latLngBounds} from 'leaflet';

export default {
  props:{
    height: {
      type: Number,
      default: 0
    }
  },
  components: {
    LMap,
    LTileLayer,
    LLayerGroup,
    LMarker
  },
  data () {
    return {
      url: `https://1.base.maps.ls.hereapi.com/maptile/2.1/maptile/newest/normal.day/{z}/{x}/{y}/512/png8?apiKey=V1raA-ef8tFmHjlffvAlvCHiNG2sepgapwewFRmiGNQ`,
      zoom: 8,
      minZoom: 8,
      center: [-34.6083, -58.3712],
      markersInMap: [],
      bounds:[],
      maxBounds: latLngBounds([
        [this.$config.BOUNDING_BOX[3], this.$config.BOUNDING_BOX[2]],
        [this.$config.BOUNDING_BOX[1], this.$config.BOUNDING_BOX[0]]
      ]),
      marker:{
        location:[0,0],
        id: '',
        title: ''
      },
      draggers: [],
      markerDraggedIndex: undefined,
      disabledMap: this.$config.DISABLED_MAP
    };
  },
  computed: {
    markers: function(){
      return this.$store.getters.getResources
    },
    style () {
      return 'height:' + 385 + 'px'
    },
    
  },
  watch:{
    markers: function(newVal, oldVal){
      if(newVal === oldVal){
        return null
      }
      this.refreshMap()
    }
  },
  mounted(){
  },
  methods:{
    getPoints(){
      var locations = []
      this.markers.forEach(extraction=>{
        if(locations.findIndex(loc=> loc.name === extraction.name)===-1)
          if((extraction.latitude!==0)&&(extraction.longitude!==0))
            locations.push({id: extraction.id,location:[extraction.latitude, extraction.longitude], name: extraction.name})
      })
      return locations
    },
    refreshMap(){
      if(this.markers.length>0){
        var extractionsMarkers = this.getPoints()
        var mapMarkers = []
        if(this.markersInMap.length > 0){
          this.markersInMap.splice(0,this.markersInMap.length)
        }
        extractionsMarkers.forEach(extMarker=> {
          var marker= {location: [extMarker.location[0],extMarker.location[1]], id:extMarker.id, title:extMarker.name, draggable:true }
          mapMarkers.push(marker)
        })
        if(mapMarkers.length ===0){
          return null
        }
        this.markersInMap = mapMarkers
        this.bounds = new latLngBounds(extractionsMarkers.map(em=>[em.location]));
        this.draggers = this.markersInMap
      }
    },
    clickOnMarker(event){
      this.$store.dispatch('setResourceFromMap', {id: event.sourceTarget.options.customId, name:event.sourceTarget.options.title,}) 
    },
    beginDrag(event){
      this.markerDraggedIndex = this.markersInMap.findIndex(el=> el.id===event.sourceTarget.options.customId)
      this.markersInMap[this.markerDraggedIndex].draggable = false  
      this.$store.dispatch('setMarkerInfo', {id: event.sourceTarget.options.customId, name: event.sourceTarget.options.title})
      setTimeout(this.reEnableDrag,2000)  
    },
    reEnableDrag(){
      this.markersInMap[this.markerDraggedIndex].draggable = true
    }
  }
}
</script>

<style scoped>
.marker{
  cursor:pointer;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  -o-user-select:none;
  user-select:none;
}



@media (max-width: 850px) {
  #mapid {
    height: 320px!important;
    width: 95%;
  }
}

@media (max-width: 650px) {
  #mapid {
    height: 230px!important;
    width: 95%;
  }
}
@media (max-width: 450px) {
  #mapid {
    width: 93%;
  }
}
</style>